export default {
    //罗马尼亚语
    DiagnosticReport:'Raport de diagnostic',
    troubleCode:'cod de eroare',
    time:'timpul',
    noTItle:'Controlul producătorului',
    TestReport:'Raport de test',
    VehicleInformation:'Informații vehicul',
    DataStream:'Flux de date',
    IMReadiness:'Pregătire I/M',
    Communication:'Protocol de comunicare',
    notFaultCode:'Fără cod de eroare',
    nodataflow:'Fără flux anormal de date',
    PositioningPrompt:'Activează funcția de localizare pentru a obține prețurile locale.',
    FaultCode:'Codul de eroare',
    AIDiagnosis:'Diagnosticul AI',
    AIWait:'Raport AI sau așteptare diagnostic automat',
    FailedFaultCode:'Nu se poate obține informația despre codul de eroare',
    AIError:'Eșec analiză AI',
    more:'Mai mult',
    StoredCodes:'Confirmă codul de eroare',
    PendingCodes:'Aștept cod eroare',
    PermanentCodes:'Cod de eroare permanent',
    ManufacturerControl:'Definit de producătorul auto',
    continue:'Continuă',
    // 引导定位
    notlimits:'Nu se poate obține permisiunea de poziționare',
    setupSteps:'Pașii de configurare:',
    openset:'Deschide aplicația "Setări"',
    findSet:'Găsiți aplicația pe care o folosiți',
    clickset:'Apasă "Locație"',
    selectLimits:'Alege "în timpul utilizării" sau "în permanență"',
    blackRefresh:'Înapoi la aplicație Actualizare pagină',
    openAppSet:'Apasă "Gestionare aplicații" sau "Aplicații"',
    findUseBrowser:'Găsiți browserul pe care îl folosiți',
    clickAuthority:'Apasă "Gestionare permisiuni"',
    findejurisd:'Găsește permisiunea "Locație"',
    selectjurisd:'Selectați "Permite" sau "Permite atunci când este utilizat"',
    phoneJurisd:'Verificați permisiunea de localizare a aplicației mobile:',
    openJurisd:'Activează permisiunea "Poziție"',
    report:'Raport',
    AI:'AI',
    Freeze:'cadru înghețat',
    VoltageInfo:'Informații despre tensiune',
    Voltage:'Tensiunea',
    Agent:'Agent'
}